import React from 'react'
import {
  playMPELogo,
  pageNotFoundBackground,
  pageNotFoundIcon,
  pageNotFoundMsg
} from 'images'

// eslint-disable-next-line react/prefer-stateless-function
export class Fallback extends React.PureComponent {
  render() {
    return (
      <section
        className="page_not_found_container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundImage: `url(${pageNotFoundBackground})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '100vh'
        }}
      >
        <div
          className="logo_container"
          style={{ display: 'flex', marginTop: '120px' }}
        >
          <div className="plaympe_logo" style={{ alignSelf: 'center' }}>
            <img src={playMPELogo} width="386" height="94" alt="Plaympe Logo" />
          </div>

          <div className="page_not_found_icon" style={{ marginLeft: '50px' }}>
            <img
              src={pageNotFoundIcon}
              width="177"
              height="208"
              alt="Plaympe Logo"
            />
          </div>
        </div>
        <div className="details">
          <img
            src={pageNotFoundMsg}
            width="902"
            height="192"
            alt="Plaympe Logo"
          />
        </div>
      </section>
    )
  }
}

//export default Fallback;
